module.exports = __webpack_public_path__ + "static/media/ledger.5c532b72.png";